import { Theme } from '@mui/material';
import { createTheme } from './createTheme';

const defaultTheme = createTheme();

let currentTheme = defaultTheme;

export function getCurrentTheme() {
    return currentTheme;
}

export function changeTheme(theme: Theme): Theme {
    currentTheme = theme;
    return currentTheme;
}
